export default __webpack_public_path__ + "static/media/air_purifier1.11e7eb3c.jpg";